import { ASYNC_START, ASYNC_END, LOGIN, LOGOUT } from "./types";
import AuthService from "../services/auth.service";
import AuthTokenService from "../services/auth-token.service";
import TenantService from "../services/tenant.service";

export const loginWithCredentials = (email, password) => dispatch => {
  dispatch({ type: ASYNC_START, subtype: LOGIN });

  AuthService.login(email, password)
    .then(result => {
      dispatch({ type: ASYNC_END });

      TenantService.purge();

      const authToken = result.headers.authorization;
      if (authToken) AuthTokenService.store(authToken);

      dispatch({ type: LOGIN, payload: result });
    })
    .catch(error => {
      dispatch({ type: ASYNC_END });
      dispatch({ type: LOGIN, payload: error.response, error: true });
    });
};

export const logOut = () => dispatch => {
  dispatch({ type: ASYNC_START });

  AuthService.logout()
    .then(result => {
      dispatch({ type: ASYNC_END });

      AuthTokenService.purge();
      TenantService.purge();

      dispatch({ type: LOGOUT });
    })
    .catch(error => {
      AuthTokenService.purge();
      TenantService.purge();

      dispatch({ type: ASYNC_END });
      dispatch({ type: LOGOUT, error: true });
    });
};
